var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-0 pl-md-3 pr-md-4 text-center background-grey"},[_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t('GLEAM_BANNER_PROMO_TEXT_SUBSCRIPTION').replace(/#PR_NAME#/g, this.$config.CustomProductData.currentPrName))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }